/**
 * Install 1.20 — copy for the Cloudflare connect 409
 * `route_bound_to_other_worker`: the domain's `{domain}/*` route already
 * runs one of the merchant's own Workers, and Sill does not take it over
 * (that would switch their Worker off). Names the Worker when the API
 * returned its name (the merchant's own Cloudflare data, name only).
 */
export const CLOUDFLARE_ROUTE_IN_USE_REASON = 'route_bound_to_other_worker';

const WORKER_NAME_RE = /^[A-Za-z0-9_-]{1,63}$/;

export function cloudflareRouteInUseMessage(
  server_body: Readonly<Record<string, unknown>> | null | undefined,
): string {
  const name = server_body?.['existing_worker'];
  const who = typeof name === 'string' && WORKER_NAME_RE.test(name)
    ? `your Worker "${name}"`
    : 'another Worker';
  return `This domain's main route in Cloudflare already runs ${who}. Sill did not replace it, so your site is unchanged. `
    + 'To use Sill, remove that route or point it at the Sill Worker in Cloudflare (Workers Routes), then deploy again, or install the Sill Worker by hand.';
}
